export enum EUIComponent {
    Checkbox = 'CheckboxWrapper',
    Incremental = 'IncrementalWrapper',
    StreetAutocomplete = 'StreetAutocomplete',
    PhoneNumberVerificationCode = 'PhoneNumberVerificationCode',
    PropertyRating = 'PropertyRating',
    Radio = 'RadioWrapper',
    RadioCard = 'RadioCardWrapper',
    Select = 'SelectWrapper',
    TextArea = 'TextAreaWrapper',
    TextField = 'TextFieldWrapper',
}

export enum EStepComponent {
    EstimationResult = 'EstimationResult',
    Identity = 'Identity',
    Loading = 'Loading',
    Location = 'Location',
    PhoneNumberVerification = 'PhoneNumberVerification',
    Profile = 'Profile',
    UpdateForm = 'UpdateForm',
}

export enum EConstructionPeriod {
    Before1870 = 'before1870',
    Between1871And1913 = '1871to1913',
    Between1914And1944 = '1914to1944',
    Between1945And1969 = '1945to1969',
    Between1970And1979 = '1970to1979',
    Between1980And1989 = '1980to1989',
    Between1990And1999 = '1990to1999',
    Between2000And2009 = '2000to2009',
    After2010 = 'after2010',
    IDontKnow = 'iDontKnow',
}

export enum EMediaComponent {
    Individual = 'individual',
    Professional = 'professional',
    Apartment = 'apartment',
    House = 'house',
    BlockedView = 'blocked-view',
    ClearView = 'clear-view',
    OutstandingView = 'outstanding-view',
    TwoFacades = 'two-facades',
    ThreeFacades = 'three-facades',
    FourFacades = 'four-facades',
}

export enum ParentBenefit {
    Basement = 'basement',
    PrivateGarden = 'privateGarden',
    BalconiesAndTerracesSurface = 'balconiesAndTerracesSurface',
    OutdoorParking = 'outdoorParking',
    IndoorParking = 'indoorParking',
}
